import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'
import { RequestUpgradeRequestDTO } from '@core/api/dtos/request/account/requestUpgrade'
import { SubscribeRequestDTO } from '@core/api/dtos/request/account/subscribe'
import { UpdateSubscriptionRequestDTO } from '@core/api/dtos/request/account/updateSubscription'
import { UpgradeStatusRequestDTO } from '@core/api/dtos/request/account/upgradeStatus'
import { SubscriptionResponseDTO } from '@core/api/dtos/response/accounts/subscription'

interface UpdateSubscriptionResponse {
	data: SubscriptionResponseDTO
}

export const subscriptionService = {
	/**
	 * Get account upgrade status
	 */
	getUpgradeStatus(
		data: UpgradeStatusRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.post('/accounts/upgrade/status', data, config)
	},

	/**
	 * Get subscription plans
	 */
	getSubscriptionPlans(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/subscription_plans', config)
	},

	/**
	 * Request upgrade
	 */
	requestUpgrade(
		data: RequestUpgradeRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.post('/subscriptions/upgrade', data, config)
	},

	/**
	 * Subscribe to a plan (create new subscription or upgrade trial)
	 */
	subscribe(
		data: SubscribeRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse<UpdateSubscriptionResponse>> {
		return apiClient.post('/accounts/subscribe', data, config)
	},

	/**
	 * Update subscription (change plan, period cycle, or zone quantity)
	 * Note: This endpoint validates the request but may not apply changes yet.
	 * It will reject if trying to reduce zones below current usage.
	 */
	updateSubscription(
		subscriptionId: number,
		data: UpdateSubscriptionRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse<UpdateSubscriptionResponse>> {
		return apiClient.patch(`/my/subscriptions/${subscriptionId}`, data, config)
	},
}
